
import React from 'react';
import { TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { TrendingUp, TrendingDown } from 'lucide-react';
import { formatCurrency } from '@/components/borrowings/debt/utils';
import { TimeHorizon } from '../index';
import { useNavigate } from 'react-router-dom';

interface NetPositionRowProps {
  totals: { netPosition: Record<string, number> };
  currentHorizons: TimeHorizon[];
  onOpenBorrowSheet: (amount: number, horizonLabel: string) => void;
}

const NetPositionRow = ({ 
  totals, 
  currentHorizons, 
  onOpenBorrowSheet 
}: NetPositionRowProps) => {
  const navigate = useNavigate();

  const handleInvestClick = (amount: number, horizonLabel: string) => {
    navigate(`/alm/investments?tab=operations&amount=${amount}&horizon=${encodeURIComponent(horizonLabel)}`);
  };

  return (
    <TableRow className="font-medium bg-muted/30">
      <TableCell>Net Position</TableCell>
      {currentHorizons.map(horizon => {
        const value = totals.netPosition[horizon.id];
        const isPositive = value >= 0;
        
        return (
          <TableCell 
            key={horizon.id} 
            className={`text-right ${isPositive ? 'text-green-600' : 'text-red-600'}`}
          >
            <div className="flex flex-col items-end gap-2">
              <div className="flex items-center justify-end">
                {isPositive ? 
                  <TrendingUp className="h-4 w-4 mr-1" /> : 
                  <TrendingDown className="h-4 w-4 mr-1" />
                }
                {formatCurrency(value)}
              </div>
              {isPositive ? (
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="bg-green-50 border-green-200 hover:bg-green-100 hover:text-green-700 text-green-600"
                  onClick={() => handleInvestClick(value, horizon.label)}
                >
                  Invest
                </Button>
              ) : (
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="bg-red-50 border-red-200 hover:bg-red-100 hover:text-red-700 text-red-600 font-medium"
                  onClick={() => onOpenBorrowSheet(value, horizon.label)}
                >
                  Borrow
                </Button>
              )}
            </div>
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default NetPositionRow;
